import ActionButton from 'components/ActionButton';
import AddCalculatedItemModal from 'components/AddCalculatedItemModal';
import Currency from 'components/Currency/Currency';
import { Loading } from 'components/loading/Loading';
import { tableStyles } from 'css/tableStyles';
import React, { useMemo, useState } from 'react';
import { useEffect } from 'react';
import DataTable from 'components/DataTable';
import { fetchCalculatedItems } from 'services';
import { USER_ROLES, isUserAuthorized } from 'utils';
import styles from './index.module.scss';
import CustomLink from 'components/TableLink';

const CalculatedItems = props => {
  const isUserAuthorizedToEdit = isUserAuthorized(props.userRoles, [USER_ROLES.PACKER, USER_ROLES.SUPERVISOR, USER_ROLES.MANAGER, USER_ROLES.ADMIN]);

  const [addModalOpen, setAddModalOpen] = useState<boolean>(false);
  const [calculatedItems,setCalculatedItems] = useState<Record<string,string>[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const {
    itemDetails,
  } = props;
  
  const columns = useMemo(() => [
    {
      name: 'ItemID',
      selector: 'objectId',
      sortable: false,
      width: '150px',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <CustomLink
          text={row.objectId}
          linkTo={`/inventory-items/${row.objectId}`}
        />
      ),
    },
    {
      name: 'Item Name',
      selector: 'name',
      sortable: false,
    },
    {
      name: 'Price',
      selector: 'price',
      sortable: false,
      // eslint-disable-next-line react/display-name
      format: (row) => (<Currency amount={parseFloat(row.price?.toFixed(2))} default={'-'} />),
    },
    {
      name: 'Multiplier',
      selector: 'multiplier',
      sortable: false,
    },
    {
      name: 'Unit',
      selector: 'unit',
      sortable: false,
      omit: !isUserAuthorizedToEdit,
      // eslint-disable-next-line react/display-name
      cell: row => (
        <div>{row.unit?.description || ''}</div>
      ),
    }], []);

  const fetchListData = async ()=>{
    try {
      setLoading(true);
      const results = await fetchCalculatedItems(itemDetails?.objectId);
      setCalculatedItems(results);
    } catch(e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    fetchListData();
  },[]);
  
  if (loading) return <Loading />;

  return (
    <>
      {addModalOpen && (
        <AddCalculatedItemModal
          parentItemDetails={itemDetails}
          onSuccess={() => fetchListData()}
          toggleModal={()=>setAddModalOpen(!addModalOpen)}
        />
      )}
      <div className={styles['related-items-container']}>
        <div className={styles['section-header']}>
          <div className={styles['section-heading']}>Calculated Items</div>
          {isUserAuthorizedToEdit && <ActionButton
            text={<>Calculated Item <span className={'ml-3'}>+</span></>}
            active={true}
            isLoading={false}
            onClick={() => setAddModalOpen(true)}
          />}
        </div>
        <DataTable
          columns={columns}
          noHeader={true}
          data={calculatedItems}
          highlightOnHover={true}
          customStyles={tableStyles}
          pagination={false}
        />
      </div>
    </>
  );
};

export default CalculatedItems;